import { Component, OnInit } from '@angular/core';
import { LoadingService } from '../services/loading.service';
import { NgIf } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-spinner',
    templateUrl: './spinner.component.html',
    styleUrls: ['./spinner.component.scss'],
    imports: [NgIf, MatProgressSpinner]
})
export class SpinnerComponent implements OnInit {

  isLoading = false;

  constructor(private loadingService: LoadingService) {}

  ngOnInit(): void {
    this.loadingService.isLoading$.subscribe(val => {
      this.isLoading = val;
    });
  }
}